import { OnInit, Input, Component } from '@angular/core';
import { VerticalTimelineModel } from './vertical-timeline.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'vertical-timeline',
    templateUrl: './vertical-timeline.component.html',
    styleUrls: ['./vertical-timeline.component.scss']
})
export class VerticalTimelineComponent implements OnInit {

    listaHistoricos: VerticalTimelineModel[] = [];

    @Input() cor: 'default' | 'blue' | 'gray' | 'gree' | 'red';

    @Input('listahistoricosInput')
    set listahistoricosInput(historicos: VerticalTimelineModel[]) {
        this.listaHistoricos = historicos;
    }

    constructor() { }

    ngOnInit() { }
}
